<div class="firmware-verification-container" [class.loading-cursor]="isLoading$ | async">
  <h3>{{ 'firmwareVerification.title' | cxTranslate }}</h3>
  <p>{{ 'firmwareVerification.explanationText' | cxTranslate }}</p>
  <div class="media-container">
    @if (firmwareImgUrl$ | async; as imgUrl) {
      <div class="image-dialog-tag">
        <a (click)="openFirmwareImage(imgUrl)">{{ 'firmwareVerification.imgText' | cxTranslate }}</a>
      </div>
    }
    @if (firmwarePdfUrl$ | async; as pdfUrl) {
      <div class="pdf-tag">
        <a (click)="openPdfInNewWindow(pdfUrl)">{{ 'firmwareVerification.pdfText' | cxTranslate }}</a>
      </div>
    }
  </div>
  <form
    [formGroup]="verificationForm"
    (ngSubmit)="onSubmit($event)"
    id="firmware-verification-form"
    name="firmware-verification-form"
  >
    <div class="input-container">
      <div class="form-group">
        <input
          id="fv-extraId"
          required="true"
          type="text"
          class="form-control"
          placeholder="{{ 'firmwareVerification.extraId' | cxTranslate }}"
          formControlName="extraId"
        />
        <cx-form-errors [control]="$any(verificationForm).get('extraId')"></cx-form-errors>
      </div>

      <div class="btn-container">
        <div #recaptchaWrapper></div>

        <input
          class="btn-primary btn-round btn-submit"
          type="submit"
          value="{{ 'firmwareVerification.validate' | cxTranslate }}"
          [disabled]="(isLoading$ | async) || !(recaptchaInit$ | async)"
        />
      </div>
    </div>
  </form>
  <ng-container *ngIf="recaptchaInit$ | async">
    <small>
      This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
      <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
    </small>
  </ng-container>
  @if (isFormSubmitted$ | async) {
    @if (isError$ | async) {
      <ng-template [ngTemplateOutlet]="error"></ng-template>
    } @else {
      <ng-template [ngTemplateOutlet]="result"></ng-template>
    }
  }
</div>

<ng-template #result>
  @if (results$ | async; as results) {
    @if (results.length > 0) {
      <div class="firmware-results-container">
        <h3>{{ 'firmwareVerification.resutsTitle' | cxTranslate }}</h3>
        @for (result of results; track result) {
          <div class="firmware-result">
            <div class="firmware-customer-model-info">
              {{ 'firmwareVerification.customerModelInfo' | cxTranslate }}: <b>{{ result.customerModelInfo }}</b>
            </div>
            <div class="firmware-version">
              {{ 'firmwareVerification.firmwareVersion' | cxTranslate }}: <b>{{ result.firmwareVersion }}</b>
            </div>
            <div class="firmware-link">
              {{ 'firmwareVerification.firmware' | cxTranslate }}:
              <a [href]="result.url">{{ 'firmwareVerification.download' | cxTranslate }}</a>
            </div>
          </div>
        }
      </div>
    } @else if (isNoResults$ | async) {
      <ng-template [ngTemplateOutlet]="noResults"></ng-template>
    }
  }
</ng-template>

<ng-template #error>
  <div class="error-container">
    <h4>{{ 'firmwareVerification.errorText' | cxTranslate }}</h4>
  </div>
</ng-template>

<ng-template #noResults>
  <div class="no-results-container">
    <h4>{{ 'firmwareVerification.noResultsText' | cxTranslate }}</h4>
  </div>
</ng-template>
